import { DisablableOption, ModelBase } from "@models";
import { APIClass } from "@utilities/smart_api_class";

export interface ArmorType extends ModelBase {
  data_type: "armor_type";
  _id: string;
  name: string;
  description: string;
  dex_bonus_max: boolean | null; // Light = null, Medium = true, Heavy = false
  stealth_disadvantage: boolean;

  // constructor(obj?: any) {
  //   super(obj);
  //   if (obj) {
  //     this.dex_bonus_max = null;
  //     if (obj.dex_bonus_max !== undefined && obj.dex_bonus_max !== null) {
  //       if (typeof(obj.dex_bonus_max) === "number" || 
  //         typeof(obj.dex_bonus_max) === "string") {
  //         const old = +obj.dex_bonus_max;
  //         this.dex_bonus_max = (old === 0 ? false : (old === 100 ? null : true));
  //       } else {
  //         this.dex_bonus_max = obj.dex_bonus_max;
  //       }
  //     }
  //     this.stealth_disadvantage = obj.stealth_disadvantage ? obj.stealth_disadvantage : false;
  //   }
  // }

  // toDBObj(): any {
  //   const base_db_obj = super.toDBObj();
  //   return {
  //     ...base_db_obj,
  //     dex_bonus_max: this.dex_bonus_max,
  //     stealth_disadvantage: this.stealth_disadvantage
  //   };
  // }

  // clone(drop_ids: boolean = false): ArmorType {
  //   const new_obj = new ArmorType();
  //   new_obj.copy(this, drop_ids);
  //   return new_obj;
  // }

  // copy(copyMe: ArmorType, drop_ids: boolean = false): void {
  //   super.copy(copyMe, drop_ids);
  //   this.dex_bonus_max = copyMe.dex_bonus_max;
  //   this.stealth_disadvantage = copyMe.stealth_disadvantage;
  // }
}

export const ARMOR_TYPES: ArmorType[] =
  [{
    data_type: "armor_type",
    _id: "5fc958e4f96ed5252811fffd",
    name: "Light",
    description: "Made from supple and thin materials, Light Armor favors agile adventurers since it offers some Protection without sacrificing mobility. If you wear Light Armor, you add your Dexterity modifier to the base number from your armor type to determine your Armor Class.",
    dex_bonus_max: null,
    stealth_disadvantage: false,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "Light",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "armor_type",
    _id: "5fd12fb57a9c0d15f0a87843",
    name: "Medium",
    description: "Medium Armor offers more Protection than Light Armor, but it also impairs Movement more. If you wear Medium Armor, you add your Dexterity modifier, to a maximum of +2, to the base number from your armor type to determine your Armor Class.",
    dex_bonus_max: true,
    stealth_disadvantage: false,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "Medium",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "armor_type",
    _id: "5fd132997a9c0d15f0a87844",
    name: "Heavy",
    description: "Of all the armor categories, Heavy Armor offers the best Protection. These suits of armor cover the entire body and are designed to stop a wide range of attacks. Only proficient warriors can manage their weight and bulk.\n\nHeavy Armor doesn’t let you add your Dexterity modifier to your Armor Class, but it also doesn’t penalize you if your Dexterity modifier is negative.",
    dex_bonus_max: false,
    stealth_disadvantage: true,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "Heavy",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }, {
    data_type: "armor_type",
    _id: "5ff36c6f5cf70f25a4e368db",
    name: "Shield",
    description: "Shields add to your AC on top of armor (or unarmored defense), and there are some abilities that they can grant.",
    dex_bonus_max: null,
    stealth_disadvantage: false,
    image_url: "",
    archived: false,
    variant_group_id: "",
    variant_group: [],
    variant_ids: [],
    is_dominant: true, is_true_dominant: true,
    dominance_level: 0,
    source_book_ids: [],
    source_book_abbrev: "",
    notes: "",
    source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
    owner_id: "",
    variant_of_id: "",
    non_version_variant: false,
    use_base_name: false,
    monster: false,
    template_only: false,
    reusable_string_ids: [],
    open_game_content: false,
    world_settings: [],
    id: "",
    variant_of_name: "",
    use_name: "",
    get_use_name: function (): string {
      throw new Error("Function not implemented.");
    },
    get_homebrewery_string: function (api: APIClass): string {
      throw new Error("Function not implemented.");
    },
    true_name: "",
    source_book_types: [],
    search_ids: [],
    toDBObj: function () {
      throw new Error("Function not implemented.");
    },
    loaded: true,
    
    toLight: function () {
      throw new Error("Function not implemented.");
    },
    copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
      throw new Error("Function not implemented.");
    },
    clone: function (drop_ids?: boolean): ModelBase {
      throw new Error("Function not implemented.");
    },
    tags: [],
    saved_without_api: false,
    get_detail_format: function() { return ""; },
    get_display_format: function() { return ""; },
    display_format: "Shield",
    detail_format: "",
    description_format: "",
    tag_string: "", free: false
  }
];

export const ARMOR_TYPE_OPTIONS = ARMOR_TYPES.map(at => {
  const opt: DisablableOption = {
    id: at._id,
    text: at.name
  }
  return opt;
});